import React, { FC } from 'react'
import { IconProps } from './types'

import logoCse from './logo-cse.png'

export const LogoCse: FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={151}
      height={55}
      viewBox="0 0 151 55"
      fill="none"
      {...props}
    >
      <image width="100%" height="100%" xlinkHref={logoCse} />
    </svg>
  )
}
